import './BlurBackground.css';

/** From Figma blur_background (137:294) — backdrop blur over gameplay. */
export function BlurBackground() {
  return <div className="pause-blur-background" aria-hidden />;
}
